<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 16 16"
       role="presentation"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" fill-rule="evenodd" d="M13.06 8c0-.238-.02-.462-.048-.686l1.477-1.155a.353.353 0 0 0 .084-.448l-1.4-2.422a.352.352 0 0 0-.427-.154l-1.743.7a5.114 5.114 0 0 0-1.183-.686l-.266-1.855A.341.341 0 0 0 9.21 1h-2.8a.341.341 0 0 0-.343.294l-.266 1.855a5.378 5.378 0 0 0-1.183.686l-1.743-.7a.341.341 0 0 0-.427.154l-1.4 2.422a.345.345 0 0 0 .084.448L2.61 7.314A5.551 5.551 0 0 0 2.56 8c0 .231.022.462.05.686L1.133 9.841a.353.353 0 0 0-.084.448l1.4 2.422c.084.154.273.21.427.154l1.743-.7c.364.28.756.511 1.183.686l.266 1.855A.341.341 0 0 0 6.41 15h2.8a.341.341 0 0 0 .343-.294l.266-1.855a5.378 5.378 0 0 0 1.183-.686l1.743.7c.16.063.343 0 .427-.154l1.4-2.422a.353.353 0 0 0-.084-.448l-1.477-1.155c.028-.224.049-.448.049-.686zm-5.25 2.45A2.453 2.453 0 0 1 5.36 8a2.453 2.453 0 0 1 2.45-2.45A2.453 2.453 0 0 1 10.26 8a2.453 2.453 0 0 1-2.45 2.45z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
